import { render, staticRenderFns } from "./timeline.vue?vue&type=template&id=d6d71a7c&scoped=true&"
import script from "./timeline.vue?vue&type=script&lang=js&"
export * from "./timeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d71a7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6d71a7c')) {
      api.createRecord('d6d71a7c', component.options)
    } else {
      api.reload('d6d71a7c', component.options)
    }
    module.hot.accept("./timeline.vue?vue&type=template&id=d6d71a7c&scoped=true&", function () {
      api.rerender('d6d71a7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platforms_portal/orders/tabs/timeline.vue"
export default component.exports